import { render, staticRenderFns } from "./childAccountList.vue?vue&type=template&id=52a1842c&lang=pug&"
import script from "./childAccountList.vue?vue&type=script&lang=js&"
export * from "./childAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports